import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
export const SetupTask = ({ expanded, index, task, onCloseModal, onExpandTask }) => {
    const isMain = expanded === index;
    if (isMain) {
        return _jsxs("div", { className: 'setup-modal__main-task', onClick: () => onCloseModal(task), "data-testid": 'close-modal', children: [_jsx("h5", { className: 'mb-3', children: task.title }), _jsx("div", { className: 'mb-1', children: task.description })] }, task.title);
    }
    return _jsx("div", { className: 'setup-modal__task', onClick: () => onExpandTask(index), "data-testid": 'expand-task', children: task.title }, task.title);
};
